import { polygonsMask } from "@churchofjesuschrist/maps-google-overlays";

export default function AreaOverlapController($scope, $state, $q, google, DataService, OrgService, MapService, MapDrawService, NotificationService, TitleService, utils, MosFrameAnalyticsService) {
	"ngInject";

	const AREA_OVERLAP_ADOBE_ANALYTICS_FORM_NAME = 'Maps - Review Overlaps';
	const vm = this;

	vm.$onInit = () => {
		vm.areaId = $state.params.areaId;
		vm.loading = true;
		vm.overlays = [];
		DataService.getArea(vm.areaId).then((area) => {
			TitleService.setTitleTranslate("pros-maps.area.overlap.title", area);

			vm.area = area;
			vm.map = DataService.instantMap();
			vm.recenter();

			// load affectedAreas
			return MapDrawService.getSelectablePolygons(vm.area).then((results) => {
				vm.affectedAreas = [vm.area].concat(results.overlappingAreas).sort(utils.sortOrgs);

				DataService.setMapOpts({selectedOrg: vm.area, automaticOrgs: vm.affectedAreas, labelsClean: true});

				// grayout outside affectedAreas
				//TODO: fix? http://imos-loc.ldschurch.org:8080/pros-maps/2011050/areas/7139074/overlap
				vm.mask = polygonsMask(results.border, {map: vm.map});
				vm.overlays.push(vm.mask);

				// map overlap
				let overlaps = MapDrawService.createOverlappingPolygons(results.selectable);
				return MapService.merge(overlaps).then((overlap) => {
					if (overlap) {
						overlap.setOptions(angular.extend({map: vm.map}, MapDrawService.styles.POLYGON_ALERT));
						vm.overlays.push(overlap);
					} else {
						vm.noOverlaps = true;
					}
					vm.matches = results.selectable.every(MapDrawService.isPolygonSelected);

					MosFrameAnalyticsService.formStart(AREA_OVERLAP_ADOBE_ANALYTICS_FORM_NAME);
					vm.loading = false;
					if ($scope.$$destroyed) {
						vm.cleanup();
					}
				});
			}, NotificationService.exception(vm, "pros-maps.error.sync"));
		});

		$scope.$on("$destroy", vm.cleanup);
	};

	vm.cleanup = () => {
		MapDrawService.removeOverlays(vm.overlays);
	};

	vm.recenter = () => {
		MapService.centerMap(vm.area, vm.map);
	};

	vm.defineArea = () => {
		$state.go("area-boundary", {areaId: vm.areaId});
	};

	vm.reviewed = () => {
		vm.loading = true;
		// update boundaryStatus
		OrgService.updateAreaBoundaryStatus(vm.areaId, vm.matches ? "MATCH" : "DEFINED").then((area) => (
			// update org data
			DataService.updateArea(area).then((area) => {
				NotificationService.success("pros-maps.success.saved.area", null, area);
				MosFrameAnalyticsService.formSubmit(AREA_OVERLAP_ADOBE_ANALYTICS_FORM_NAME);
				vm.exit();
			})
		), () => {
			NotificationService.exception(vm);
			MosFrameAnalyticsService.formError(AREA_OVERLAP_ADOBE_ANALYTICS_FORM_NAME, ['server-error']);
		});
	};

	vm.exit = () => {
		$state.go("area", {areaId: vm.areaId});
	};

}
